<template>
  <section class="is-flex is-flex-direction-column is-full-height m-t-10">
    <div class="is-full-height">
      <div
        v-for="n in [1, 2, 3, 4]"
        :key="n"
        class="items-loaders is-flex is-flex-direction-row m-l-20 m-t-8"
      >
        <div>
          <SkeletonView class="dark" height="30" width="30" circle />
        </div>
        <div class="is-flex is-align-items-center is-full-width m-l-10">
          <SkeletonView class="dark" height="25" width="80%" />
        </div>
      </div>
    </div>
    <div class="m-b-20">
      <div
        v-for="n in [1]"
        :key="n"
        class="items-loaders is-flex is-flex-direction-row m-l-20 m-t-8"
      >
        <div>
          <SkeletonView class="dark" height="30" width="30" circle />
        </div>
        <div class="is-flex is-align-items-center is-full-width m-l-10">
          <SkeletonView class="dark" height="25" width="80%" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'MainNavLoader',
  components: { SkeletonView }
};
</script>

<style scoped>
.items-loaders :deep(.b-skeleton-item.is-rounded) {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  margin-bottom: var(--ce-15px);
}
</style>
